import React from "react";
import { X } from "lucide-react";

const severityStyles = {
  warning: "bg-emerald-50 border-emerald-200 text-emerald-900",
  danger: "bg-emerald-50 border-emerald-200 text-emerald-900",
  success: "bg-emerald-50 border-emerald-200 text-emerald-900",
  info: "bg-emerald-50 border-emerald-200 text-emerald-900",
};

export default function AlertBar({ alerts = [], onDismiss, className = "" }) {
  if (!alerts.length) return null;

  return (
    <div
      className={`px-4 sm:px-6 lg:px-8 py-1 ${className}`}
    >
      {alerts.map((alert) => {
        const palette =
          severityStyles[alert.type] ?? severityStyles.info;
        return (
          <div
            key={alert.id}
            className={`flex items-center justify-between gap-3 rounded-lg border px-4 py-2 text-sm shadow-sm ${palette}`}
          >
            <div className="flex-1 min-w-0">
              {alert.title && (
                <p className="font-semibold truncate">{alert.title}</p>
              )}
              {/* 
              <p className="leading-5">{alert.message}</p>
              */}
            </div>
            <button
              type="button"
              aria-label="Dismiss alert"
              onClick={(e) => {
                e.stopPropagation();
                if (onDismiss) onDismiss(alert.id);
              }}
              className="ml-2 flex-shrink-0 text-inherit hover:opacity-70 cursor-pointer focus:outline-none"
            >
              <X size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
